import NavigationStore from '../stores/NavigationStore';
import loadQuickstarts from './loadQuickstarts';
var loadLandingPage = function (context, payload) {
    var _a;
    var navigationSections = context.getStore(NavigationStore).getNavigationItems(payload.doc.meta.section);
    var currentNavigationSection = navigationSections === null || navigationSections === void 0 ? void 0 : navigationSections.find(function (item) { return item.url === payload.doc.meta.url; });
    var requiresQuickstartLoading = currentNavigationSection === null || currentNavigationSection === void 0 ? void 0 : currentNavigationSection.children.some(function (item) { return item === null || item === void 0 ? void 0 : item.quickstarts; });
    if (requiresQuickstartLoading) {
        return loadQuickstarts(context, { locale: (_a = payload === null || payload === void 0 ? void 0 : payload.locale) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase() });
    }
};
export default loadLandingPage;
